import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  SupplierIdSchema,
  SupplierSchema,
  SupplierListItemSchema,
  CreateSupplierSchema,
  UpdateSupplierSchema,
  ListSuppliersQuerySchema,
  DeleteSupplierRequestSchema,
} from '../schemas/supplier.js';

export const suppliers = {
  list: endpoint('GET', '/suppliers', ListSuppliersQuerySchema, z.array(SupplierListItemSchema)),
  getById: endpoint('GET', '/suppliers/:id', z.object({ id: SupplierIdSchema }), SupplierSchema),
  create: endpoint('POST', '/suppliers', CreateSupplierSchema, SupplierSchema),
  update: endpoint(
    'PATCH',
    '/suppliers/:id',
    z.object({ id: SupplierIdSchema }).merge(UpdateSupplierSchema),
    SupplierSchema,
  ),
  // DELETE returns 204 No Content — response schema is z.void() so callEndpoint
  // correctly parses the empty body without throwing a ZodError.
  // The flat request schema sends strategy/targetSupplierId directly in the HTTP
  // body (not nested under a 'body' key) so callEndpoint wires them correctly.
  delete: endpoint('DELETE', '/suppliers/:id', DeleteSupplierRequestSchema, z.void()),
};
